
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { TiposSakesService } from '../../../../services/tipos_sakes.service';
import { SakesService } from '../../../../services/sakes.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-editar-sake',
  templateUrl: './editar-sake.component.html',
  styleUrls: ['./editar-sake.component.scss']
})
export class EditarSakeComponent implements OnInit {
  tiposSakes;
  form = this.fb.group({
    numero_sake: ['',  [Validators.required, Validators.pattern('^[0-9]*$')]],
    estatus:['Activo'],
    id_tipo_sake:[,[Validators.required]],
    id_usuario:[],
    id_usuarios_creador: [sessionStorage.getItem('id_usuario')]
  });
  constructor(
    public dialogRef: MatDialogRef<EditarSakeComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any, 
    public tiposSakesService: TiposSakesService,
    public sakesService: SakesService,
    private _snackBar: MatSnackBar,
  ) { }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  ngOnInit(): void {
    this.tiposSakesService.obtenerTodos().subscribe((data:any)=>{
      //console.log(data)
      this.tiposSakes = data.payload;
    })
    //console.log(this.data)
    this.form.controls.numero_sake.setValue(this.data.numero_sake);
    this.form.controls.id_tipo_sake.setValue(this.data.id_tipo_sake);
    this.form.controls.id_usuario.setValue(this.data.id_usuario);
    this.form.controls.estatus.setValue(this.data.estatus);
  }

  onSubmit(){
    //console.log(this.form.value)
    this.form.controls.id_usuarios_creador.setValue(sessionStorage.getItem('id_usuario'));
    this.form.value.id_sakes = this.data.id_sakes;
    this.form.value.borrado = 0;
    //console.log(this.form.value)
    this.sakesService.actualizar(this.form.value ).subscribe(data=>{
      //console.log(data)
      this.openSnackBar("Sake actualizado con éxito","X")
      this.dialogRef.close();
    })
  }
}


